export let presets = [
    {
        id: 'default',
        label: 'Default',
        font: 'Poppins',
        colours: {
            standard: {
                primary: '#3460FF',
                headings: '#151F6D',
                background: '#F6F7F8'
            },
            cover: {
                primary: '#3460FF',
                headings: '',
                background: '#151F6D',
                pattern: '#3460FF'
            }
        }
    },
    {
        id: 'pine',
        label: 'Pine',
        font: 'Source Serif Pro',
        colours: {
            standard: {
                primary: '#93FC94',
                headings: '#294C52',
                background: '#E5FDC9'
            },
            cover: {
                primary: '#93FC94',
                headings: '',
                background: '#294C52',
                pattern: '#93FC94'
            }
        }
    },
    {
        id: 'maple',
        label: 'Maple',
        font: 'Nunito',
        colours: {
            standard: {
                primary: '#F4642C',
                headings: '#5C1427',
                background: '#FFEDDB'
            },
            cover: {
                primary: '#F4642C',
                headings: '',
                background: '#5C1427',
                pattern: '#F4642C'
            }
        }
    },
    {
        id: 'mauve',
        label: 'Mauve',
        font: 'Montserrat',
        colours: {
            standard: {
                primary: '#A45CFF',
                headings: '#2B1072',
                background: '#F3F1FF'
            },
            cover: {
                primary: '#A45CFF',
                headings: '',
                background: '#2B1072',
                pattern: '#A45CFF'
            }
        }
    },
    {
        id: 'berry',
        label: 'Berry',
        font: 'Noto Serif',
        colours: {
            standard: {
                primary: '#D2388A',
                headings: '#62153E',
                background: '#FFEFFD'
            },
            cover: {
                primary: '#D2388A',
                headings: '',
                background: '#62153E',
                pattern: '#D2388A'
            }
        }
    },
    {
        id: 'lime',
        label: 'Lime',
        font: 'Roboto Mono',
        colours: {
            standard: {
                primary: '#E2F261',
                headings: '#355A6D',
                background: '#FBFBEE'
            },
            cover: {
                primary: '#E2F261',
                headings: '',
                background: '#355A6D',
                pattern: '#E2F261'
            }
        }
    },
    {
        id: 'dark',
        label: 'Dark',
        font: 'DM Sans',
        colours: {
            standard: {
                primary: '#EEEEE8',
                headings: '#EEEEE8',
                background: '#0A0909'
            },
            cover: {
                primary: '#EEEEE8',
                headings: '',
                background: '#0A0909',
                pattern: '#7C7C7C'
            }
        }
    },
    {
        id: 'light',
        label: 'Light',
        font: 'DM Sans',
        colours: {
            standard: {
                primary: '#BFBFBF',
                headings: '#6A6A6A',
                background: '#F9F8F7'
            },
            cover: {
                primary: '#BFBFBF',
                headings: '',
                background: '#F9F8F7',
                pattern: '#D6D6D6'
            }
        }
    },
];
